const approvalStatuses = {
  APPROVED: "APPROVED",
  PARTIALLY_APPROVED: "PARTIALLY_APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
};

export default approvalStatuses;
